import { takeEvery, all, put, select } from 'redux-saga/effects'
import { stopSubmit, reset } from 'redux-form/immutable'

import { postProtrack } from '../actions'
import { push } from 'connected-react-router'
import { CREATE_PROTRACK_FORM_NAME as FORM_NAME } from 'app/constants/protracks'
import { showSuccess } from 'store/entities/toastr/utils'
import { getBlockedPathName } from 'store/entities/protracks/unsavedChanges/selectors'
import { reset as resetUnsavedChanges } from 'store/entities/protracks/unsavedChanges/actions'

export function* handlePostSuccess({ payload: { data }, meta: { shouldLeavePage } }) {
  const blockedPathName = yield select(getBlockedPathName)
  yield put(resetUnsavedChanges())
  yield put(reset(FORM_NAME))
  yield put(stopSubmit(FORM_NAME))
  if (shouldLeavePage && blockedPathName) {
    yield put(push(blockedPathName, { forceLeave: true }))
  }
  showSuccess({ content: `You successfully created ${data.name}` })
}

export function* handlePostFail(error) {
  console.error('error', error)
  yield put(stopSubmit(FORM_NAME))
}

export default function* unsubscribeProgressSaga() {
  yield all([
    takeEvery(postProtrack.success.toString(), handlePostSuccess),
    takeEvery(postProtrack.fail.toString(), handlePostFail),
  ])
}
